<h2>ACADEMATE History</h2>


<p>ACADEMATE is the result of efforts by researchers at the University of Hamburg. Initially, they tested whether
  large language models (LLMs) are capable of selecting relevant articles for a systematic review based on title and
  abstract screening [1]. Their findings revealed that the workload of a second reviewer in this process of conducting
  a high-quality systematic review could be reduced by 33% to 93%. Building on these findings, they developed
  ACADEMATE, focusing on enhancing the usability of LLMs for researchers conducting systematic reviews. They,
  furthermore, expanded the functionality and tested whether LLMs could also select publications based on full-text
  screening for systematic reviews. The results, based on three existing systematic reviews [2, 3, 4], which were
  already utilized in the former publication, are presented in the table below.</p>


<table mat-table [dataSource]="reviewsData" class="mat-elevation-z8" multiTemplateDataRows>
  <!-- Review Name Column -->
  <ng-container matColumnDef="review">
    <th mat-header-cell *matHeaderCellDef>Review</th>
    <td mat-cell *matCellDef="let element">{{ element.review }}</td>
  </ng-container>

  <!-- Total Original Column -->
  <ng-container matColumnDef="totalOrig">
    <th mat-header-cell *matHeaderCellDef>Number of papers included in the original review</th>
    <td mat-cell *matCellDef="let element">{{ element.totalOrig }}</td>
  </ng-container>

  <!-- Total Preprocessed Column -->
  <ng-container matColumnDef="totalPrep">
    <th mat-header-cell *matHeaderCellDef>Number of papers included for testing the LLMs</th>
    <td mat-cell *matCellDef="let element">{{ element.totalPrep }}</td>
  </ng-container>

  <!-- Screen1 Original Column -->
  <ng-container matColumnDef="screen1Orig">
    <th mat-header-cell *matHeaderCellDef>Originally included papers after title and abstract screening</th>
    <td mat-cell *matCellDef="let element">{{ element.screen1Orig }}</td>
  </ng-container>

  <!-- Screen1 Preprocessed Column -->
  <ng-container matColumnDef="screen1Prep">
    <th mat-header-cell *matHeaderCellDef>LLM-based included papers after title and abstract screening</th>
    <td mat-cell *matCellDef="let element">{{ element.screen1Prep }}</td>
  </ng-container>

  <!-- Screen2 Original Column -->
  <ng-container matColumnDef="screen2Orig">
    <th mat-header-cell *matHeaderCellDef>Originally included papers after full-text screening</th>
    <td mat-cell *matCellDef="let element">{{ element.screen2Orig }}</td>
  </ng-container>

  <!-- Screen2 Preprocessed Column -->
  <ng-container matColumnDef="screen2Prep">
    <th mat-header-cell *matHeaderCellDef>LLM-based included papers after full-text screening</th>
    <td mat-cell *matCellDef="let element">{{ element.screen2Prep }}</td>
  </ng-container>

  <!-- Header and Row Declarations -->
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>

<p style="margin-top: 16px;">
  Finally, ACADEMATE, additionally may support researchers in improving the search-query and the data extraction from
  the included articles.
</p>


<ul>
  <li>[1] Delgado-Chaves FM, Jennings MJ, Atalaia A, Wolff J, Horvath R, Mamdouh ZM, Baumbach J, Baumbach L.
    Transforming literature screening: The emerging role of large language models in systematic reviews. Proceedings
    of the National Academy of Sciences. 2025 Jan 14;122(2):e2411962122.
  </li>
  <li>[2]  L. Baumbach, W. Feddern, B. Kretzler, A. Hajek, H.-H. König, Cost-effectiveness of treatments for
    musculoskeletal conditions offered by physiotherapists: A systematic review of trial-based evaluations. Sports
    Med. Open 10, 38 (2024).
  </li>
  <li>[3]  M. J. Jennings, A. Lochmüller, A. Atalaia, R. Horvath, Targeted therapies for hereditary peripheral
    neuropathies: Systematic review and steps towards a “treatabolome”. J. Neuromuscul. Dis. 8, 383–400 (2021).
  </li>
  <li>[4]  J. Wolff, J. Pauling, A. Keck, J. Baumbach, The economic impact of artificial intelligence in health care:
    Systematic review. J. Med. Internet Res. 22, e16866 (2020).
  </li>
</ul>

